<template>
  <tr class="col-md-16">
    <td class="col-md-2">
      <TextInputField
          v-if="isEditing"
          class="form-group"
          v-model="editedFreeCostDto.description"
          labelText="Omschrijving"
          required
          minLength="1"
          maxLength="255"/>
      <span v-else>{{ editedFreeCostDto.description }}</span>
    </td>

    <td class="col-md-2">
      <NumberInputField
          v-if="isEditing"
          class="form-group"
          v-model="editedFreeCostDto.amount"
          labelText="Aantal"
          required
          maxLength="40"/>
      <span v-else>{{ editedFreeCostDto.amount }}</span>
    </td>

    <td class="col-md-2">
      <TextInputField
          v-if="isEditing"
          class="form-group"
          v-model="editedFreeCostDto.units"
          labelText="Eenheden"
          required
          minLength="1"
          maxLength="40"/>
      <span v-else>{{ editedFreeCostDto.units }}</span>
    </td>

    <td class="col-md-2">
      <NumberInputField
          v-if="isEditing"
          class="form-group"
          v-model="editedFreeCostDto.cost"
          labelText="Kost"
          required
          maxLength="40"/>
      <span v-else>{{ editedFreeCostDto.cost }}</span>
    </td>

    <td class="col-md-2">
      <div id="selector" class="form-group" v-if="isEditing">
        <label >Type Kost</label>
        <select v-model="selectedAccountingCost" class="form-control">
          <option v-bind:key="accountingCost.billingCode" v-bind:value="accountingCost" v-for="accountingCost in accountingCosts" >
            {{ accountingCost.name }}
          </option>
        </select>
      </div>
      <div v-else>
        <span>{{ editedFreeCostDto.accountingCost.name }}</span>
      </div>
    </td>
    <td class="col-md-2">{{ totalCost }}</td>

    <td class="col-md-2">
      <div class="d-flex align-items-center">
        <button class="btn btn-fill-pulse-dark m-0" @click="deleteFreeCost()">{{ isEditing ? 'Annuleren' : 'Verwijderen' }}</button>
        <button :disabled="!canSaveFreeCost" class="btn-basic btn-fill-pulse m-0" @click="toggleEditFreeCost()">{{ isEditing ? 'Opslaan' : 'Aanpassen' }}</button>
      </div>
    </td>
  </tr>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import TextInputField from "@/components/inputFields/TextInputField.vue";
import NumberInputField from "@/components/inputFields/NumberInputField.vue";

export default {
  name: "EditableFreeCostComponent",
  components: { NumberInputField, TextInputField},
  props: ["freeCostDto"],
  data: () => ({
    oldFreeCostDto: null,
    editedFreeCostDto: null,
    selectedAccountingCost: "",
    isEditing: false,
  }),
  computed: {
    ...mapGetters({
      accountingCosts: "administrationInvoice/accountingCosts"
    }),
    totalCost() {
      return this.editedFreeCostDto.amount * this.editedFreeCostDto.cost;
    },
    canSaveFreeCost() {
      return this.isTextInputValid(this.editedFreeCostDto.description) &&
          this.isNumberInputValid(this.editedFreeCostDto.amount) &&
          this.isTextInputValid(this.editedFreeCostDto.units) &&
          this.isNumberInputValid(this.editedFreeCostDto.cost) &&
          this.selectedAccountingCost !== "";
    },
  },
  created() {
    this.oldFreeCostDto = JSON.parse(JSON.stringify(this.freeCostDto));
    this.editedFreeCostDto = this.freeCostDto;
    this.selectedAccountingCost = this.freeCostDto.accountingCost;
  },
  methods: {
    ...mapActions("administrationTimeSheet", ["removeFreeCost", "updateFreeCost"]),
    isTextInputValid(text) {
      return text.trim().length > 0 && text.trim().length < 41;
    },
    isNumberInputValid(number) {
      return number > 0;
    },
    deleteFreeCost() {
      if (!this.isEditing) {
        const deleteFreeCostDto = this.generateFreeCostDto(this.freeCostDto, this.freeCostDto.accountingCost);
        this.removeFreeCost(deleteFreeCostDto);
      } else {
        this.editedFreeCostDto = JSON.parse(JSON.stringify(this.oldFreeCostDto));
      }
      this.isEditing = false;
      event.preventDefault();
    },
    toggleEditFreeCost() {
      event.preventDefault();
      if (this.isEditing) {
        const accountingCost = this.selectedAccountingCost;
        const changedFreeCostDto = this.generateFreeCostDto(this.editedFreeCostDto, accountingCost);

        const oldFreeCost = this.generateFreeCostDto(this.oldFreeCostDto, this.oldFreeCostDto.accountingCost);
        const freeCostToUpdate = {
          old: oldFreeCost,
          changed: changedFreeCostDto,
        };
        this.updateFreeCost(freeCostToUpdate);
      }
      this.isEditing = !this.isEditing;
    },
    generateFreeCostDto(freeCostDto, accountingCost) {
      const description = freeCostDto.description;
      const amount = freeCostDto.amount;
      const units = freeCostDto.units;
      const cost = freeCostDto.cost;

      return {
        description: description,
        amount: amount,
        units: units,
        cost: cost,
        accountingCostDto: accountingCost,
      };
    },
  }
};
</script>

<style scoped>

</style>